/**
 * Loads the external script to the DOM
 * @param {string} src - URL of the script
 * @returns {Promise}
 */
// eslint-disable-next-line import/prefer-default-export
export const loadScript = src =>
  new Promise(resolve => {
    const script = document.createElement('script');
    script.src = src;
    script.type = 'text/javascript';
    script.async = true;
    script.defer = true;
    script.onload = resolve;
    script.onerror = ({ target }) => {
      console.info(`Failed to load ${target.src}`);
      return null;
    };
    document.head.appendChild(script);
  });

/**
 * Loads the external stylesheets to the DOM
 * @param {string} href - HREF of the stylesheet
 * @returns {Promise}
 */
export const loadCss = href =>
  new Promise(resolve => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.onload = resolve;
    link.onerror = ({ target }) => {
      console.info(`Failed to load ${target.href}`);
      return null;
    };
    document.head.appendChild(link);
  });

export const DOMElementExistsByAttribute = (prop, value) =>
  Boolean(document.querySelector(`[${prop}='${value}']`));
